<template>
  <div v-if="translations.buttons && translations.info">
    <h3>{{ defineTitle }}</h3>
    <h1 class="p-3 mb-2 bg-warning text-white">
      <span>
        {{ defineEventTitle }}
      </span>
      <br />
      <span
        >{{ translations.event.form_code }}:
        {{ confirm.data.code }}
      </span>
    </h1>
    <!-- <h4>{{ productdelete.name }}</h4> -->

    <div class="col-12">
      <button class="btn btn-danger m-2" @click="changeToolSelected(null)">
        {{ translations.buttons.btn_cancel }}
      </button>
      <button class="btn btn-primary m-2" @click="confirmEnable()">
        {{ translations.buttons.btn_caonfirm }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'ToolConfirmEnable',
    computed: {
      ...mapState(['confirm', 'translations', 'languageSelected']),
      defineTitle() {
        if (this.translations.info && this.translations.activity) {
          let result = this.translations.info.enable_event
          switch (this.confirm.type) {
            case 'event':
              result += this.translations.event.name
              break
          }
          return result + '?'
        }
      },
      defineEventTitle() {
        let text = ''
        if (
          this.confirm.data.title &&
          typeof this.confirm.data.title == 'object'
        ) {
          let result = this.confirm.data.title.find(
            (x) => x.key === this.languageSelected
          )
          text =
            result && result.text
              ? result.text
              : this.confirm.data.title[0].text
        }
        return text
      },
    },
    methods: {
      ...mapActions(['confirmEnable', 'changeToolSelected']),
    },
  }
</script>

<style></style>
